import { IconButton, Grid, Typography, Box } from '@material-ui/core'
import React from 'react'
import StatusViewer from './VisualizadorStatus'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  iconButton: {
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }
}))

const ResumoClassificacao = ({ titulo, nota, src, itens, isPrinting }) => {
  const classes = useStyles()
  const handleClick = () => {
    if (src) {
      window.open(src)
    }
  }

  return (
    <Grid container spacing={isPrinting ? 0 : 2} alignItems="flex-start">
      <Grid item xs={2}>
        <Grid container spacing={isPrinting ? 0 : 1} alignItems="center">
          {src && !isPrinting && (
            <Grid item xs={4} sm={3}>
              <IconButton
                className={classes.iconButton}
                onClick={handleClick}
                color="primary"
                size="small"
              >
                <OpenInNewIcon />
              </IconButton>
            </Grid>
          )}
          <Grid item xs>
            <Typography>
              <Box fontWeight="fontWeightBold">{titulo}</Box>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs>
        <Grid container spacing={isPrinting ? 1 : 4}>
          {itens.map(item => {
            return (
              <Grid
                item
                xs={isPrinting ? 6 : 12}
                sm={6}
                md={4}
                xl={2}
                key={`${titulo}-${item.titulo}`}
              >
                <StatusViewer
                  titulo={item.titulo}
                  status={item.status}
                  mensagemAlerta={item.mensagemAlerta}
                />
              </Grid>
            )
          })}
        </Grid>
      </Grid>
      {!isPrinting && (
        <Grid item xs={2}>
          <Typography align="right">
            <Box fontWeight="bold">{nota} pontos</Box>
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default ResumoClassificacao
